import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutStatus } from '../LayoutStatusContext';
import {
  headerLayout as headerLayoutIcon,
  footerLayout as footerLayoutIcon,
  notFoundLayout as notFoundLayoutIcon,
} from "../Icons";
import { Dashicon } from "@wordpress/components";
import MoreOptions from './MoreOptions';
import {__} from '@wordpress/i18n';

const CreatedLayouts = ({ layout, showTitle = false, title = '' }) => {

  const navigate = useNavigate();
  const { getStatus, updateStatus } = useLayoutStatus();
  let navigateTo = '/';

  if ( title === 'Header' ) navigateTo = '/header';
  if ( title === 'Footer' ) navigateTo = '/footer';
  if ( title === '404' )    navigateTo = '/404';

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const handleEllipsisClick = (event, index) => {
    event.stopPropagation();
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const closeMenu = () => {
    setOpenMenuIndex(null);
  };

  useEffect(() => {
    const handleClickOutside = () => closeMenu();
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

    useEffect(() => {
      layout?.forEach((layout) => {
        // Disable if post_status is not 'publish'
        if (layout?.post_status !== 'publish') {
          updateStatus(layout.ID, 'disabled');
        }

      });
    }, [layout]);

  return (
    <>
    {showTitle && <h2 className="text-base text-[#53515A] uppercase font-medium mb-4 mt-8">{title}</h2>}
      <div className="flex flex-wrap gap-6">
        {layout.map((current, index) => (
          <div
            key={current.ID || index}
            className="relative group min-w-[240px] transition-shadow duration-300 shadow-cardShadow"
          >
            <div className="flex flex-col gap-3 rounded-md shadow-md overflow-hidden h-full">
              <div className="flex gap-2 items-center justify-between bg-white pt-6 px-6">
                <div className="flex items-center gap-1.5">
                  <div className={`w-1.5 h-1.5 ${getStatus(current.ID, current.layout_status) ? 'bg-red-600' : 'bg-green-600' } rounded-full`}></div>
                  <h3 className="m-0 text-sm text-center">
                    {current?.post_title
                      ? current.post_title.length > 10
                        ? current.post_title.substring(0, 10) + "..."
                        : current.post_title
                      : __("(untitled)", "responsive-addons")}
                    {"publish" !== current?.post_status && " (" + current?.post_status + ")"}
                  </h3>
                </div>
                <button
                  onClick={(e) => handleEllipsisClick(e, index)}
                  className="flex items-center cursor-pointer"
                >
                  {openMenuIndex !== index && (
                    <Dashicon size={16} icon="ellipsis" className="rotate-90" />
                  )}
                  {openMenuIndex === index && <Dashicon icon="no-alt" />}
                </button>
              </div>
              <div className="bg-white relative">
                <div className="pb-6 px-6 w-full group-hover:blur-sm transition">
                  {current.layout_value === "header" && headerLayoutIcon}
                  {current.layout_value === "footer" && footerLayoutIcon}
                  {current.layout_value === "404-page" && notFoundLayoutIcon}
                </div>
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-md">
                  <button
                    className="w-[136px] h-[40px] flex items-center justify-center gap-2.5 rounded border border-transparent bg-btnPrimary hover:bg-sky-600 text-white text-sm font-medium shadow-md"
                    onClick={() => window.open( current?.edit_post_link, "_blank" )}
                  >
                    <Dashicon icon="edit" />
                    {__( 'Edit', 'responsive-addons' )}
                  </button>
                  <button
                    className="w-[136px] h-[40px] flex items-center justify-center gap-2.5 rounded border border-btnPrimary text-btnPrimary hover:border-sky-600 hover:text-sky-600 text-sm font-medium shadow-md bg-white"
                    onClick={() => navigate(navigateTo)}
                  >
                    <Dashicon icon="visibility" />
                    {__( 'Quick View', 'responsive-addons' )}
                  </button>
                </div>

              </div>
            </div>

            {/* Popup Menu */}
            {openMenuIndex === index && (
              <MoreOptions
                postID={current?.ID}
                postLink={current?.post_link}
                index={index} layout={layout}
                layoutStatus={current?.layout_status}
                postStatus={current?.post_status}
              />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CreatedLayouts;
